module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"noMessages":"This is the beginning of your conversation with {fullName}"}}')
  delete Component.options._Ctor
}
